<template>
    <div data-cy="list_mission_transaction_items">
        <div v-for="(mission,index) in transactionList"
                        :key="mission">
            <MissionTransactionItems
                data-cy="component_mission_transaction_item"
                :mission="mission"
                :index="index"
            />
        </div>
    </div>
</template>
<script>
//component
import MissionTransactionItems from './MissionTransactionItems.vue';
export default {
    name: "MissionTransaction",
    props: {
        transactionList: { type: Object , required: false }
    },
    components: {
        MissionTransactionItems,
    },
}
</script>
